import { HTMLAttributes } from "react";

import { list } from "../List/list.style";

type RichTextContentProps = {
    text: string;
    className?: string;
    ref?: React.Ref<HTMLDivElement>;
    style?: HTMLAttributes<HTMLDivElement>["style"];
};

const RichTextContent = ({
    text,
    className,
    ref,
    style
}: RichTextContentProps) => {
    const hasUnorderedList = !!~text.indexOf("<ul>");
    const hasOrderedList = !!~text.indexOf("<ol>");

    return (
        <div
            className={list({ hasUnorderedList, hasOrderedList, className })}
            ref={ref}
            style={style}
            dangerouslySetInnerHTML={{
                __html: text
            }}
        ></div>
    );
};

export { RichTextContent };
